import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  grid: {
    flexGrow: 1,
  },
  paper: {
    cursor: 'pointer',
    height: 269,
    width: 248,
    border: '1px solid #D9D9D9',
    borderRadius: 10,
    marginBottom: 27,
    boxShadow: '0px 3px 6px #00000029',
    margin: 'auto',
    '&:hover, &:focus': {
      border: '1px solid #6A148E',
    },
  },
  container: {
    height: 'auto',
  },
  title: {
    fontSize: '20px',
    marginTop: '44px',
    marginBottom: '13px',
    fontWeight: 600,
  },
  summary: {
    fontSize: '14px',
    marginBottom: '43px',
  },
  imageCard: {
    marginTop: '9px',
    marginRight: '8px',
    marginLeft: '8px',
  },
  rLogoCard: {
    height: '31px',
    width: '113px',
    margin: 'auto',
  },
  containerLogo: {
    width: '100%',
    textAlign: 'center',
    marginTop: '23px',
  },
});

export default useStyles;
